import _lodash from 'lodash'
import moment from 'moment/moment'

export function initData(data) {
  const addData = data || (sessionStorage.getItem('addData') ? JSON.parse(sessionStorage.getItem('addData')) : { item_info: {} })
  addData.credentialData = {
    ...addData.credentialData,
    ...addData.brand_qualification,
    type: _lodash.get(addData, 'brand_qualification.brand_id') ? 'updata' : 'add',
    validTime: _lodash.get(addData, 'brand_qualification.begin_time') ? [moment(_lodash.get(addData, 'brand_qualification.begin_time')), moment(_lodash.get(addData, 'brand_qualification.end_time'))] : [],
    files: (_lodash.get(addData, 'brand_qualification.files') || []).map(url => ({ response: { url }, name: url.split('/').pop() }))
  }
  if (!_lodash.get(addData, 'item_info.brand_id') && _lodash.get(addData, 'item_info.brand_name')) {
    _lodash.set(addData, 'item_info.brand_id', _lodash.get(addData, 'item_info.brand_name'))
  }
  sessionStorage.setItem('addData', JSON.stringify(addData))
  console.log('local', addData, data)
  return addData
}

export function deepCopy(data) {
  if (typeof data != "object") {
    return data;
  }
  if (data == null) {
    return data;
  }
  let newObj = data.constructor === Array ? [] : {};  //开辟一块新的内存空间
  for (let i in data) {
    newObj[i] = deepCopy(data[i]);
  }
  return newObj;
}


// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/addinfomation/utils.js